import styled from 'styled-components/macro';

// tslint:disable-next-line:variable-name
export const HighlightEditButtons = styled.div`
  display: flex;
  align-items: center;
  overflow: visible;
  gap: 1rem;
  height: min-content;
`;
